<app-nav titulo="Detalles de la propiedad" descripcion="Aqui podrá ver toda la información que tenemos acerca de la propiedad seleccionad.">
    <div class="property-details">
        <app-property-details-content [property]="property" *ngIf="property"></app-property-details-content>
    </div>
</app-nav>
